import { Injectable } from '@angular/core';
import { LiveLessonId } from '@pcp/core/interfaces';
import { Endpoint } from '@pcp/http';
import { Observable } from 'rxjs';

interface AzureCommunicationsTokenUserResponse {
    // user: {
    //     communicationUserId: string;
    // };
    // token: string;
    // expiresOn: Date;
    token: string;
}

/**
 * Authenticate against PCP using an ENET Token.
 * This is the entry-point in the Live App (initial login).
 */
@Injectable({
    providedIn: 'root'
})
export class PcpLiveLoginTokenAuthenticator {

    /**
     * Fetch a JWT from the PCP API
     * - which contains information about the current user
     * - token for azure communication access
     */
    private readonly tokenForStreamingAppUrl = '/api/live-lesson/auth';

    constructor(private readonly endpoint: Endpoint) {}

    getTokenForModerator(liveLessonId: LiveLessonId, liveLessonLoginToken: string): Observable<AzureCommunicationsTokenUserResponse> {
        return this.endpoint.get<AzureCommunicationsTokenUserResponse>(`${this.tokenForStreamingAppUrl}/moderator/${liveLessonId}?token=${liveLessonLoginToken}`);
    }

    getTokenForStudent(liveLessonId: LiveLessonId, liveLessonLoginToken: string): Observable<AzureCommunicationsTokenUserResponse> {
        return this.endpoint.get<AzureCommunicationsTokenUserResponse>(`${this.tokenForStreamingAppUrl}/student/${liveLessonId}?token=${liveLessonLoginToken}`);
    }
}
